export const content = {
  es: {
    nav: {
      home: "Inicio",
      portfolio: "Portafolio",
      projects: "Proyectos",
      capabilities: "Servicios",
      contact: "Contacto",
      kanan: "Kanan",
      marchantite: "Marchantite",
      niya: "Niya",
      blebe: "Blebé"
    },
    hero: {
      badge: "The Dark Side MX",
      t1: "Construcción de Proyectos",
      t2: "Digitales & Escalables",
      d: "Materializamos su visión digital. Creamos ecosistemas de software de alto rendimiento diseñados para optimizar la rentabilidad y el crecimiento de su modelo de negocio.",
      cta: "Iniciar Proyecto",
      explore: "Ver Capacidades"
    },
    services: {
      title: "Ingeniería de Software",
      subtitle: "Soluciones de Alto Nivel",
      viewProject: "Visitar Proyecto",
      web: {
        t: "Ecosistemas Web",
        d: "Arquitecturas escalables para SaaS y plataformas corporativas que exigen alta disponibilidad y velocidad de carga extrema."
      },
      mobile: {
        t: "Ingeniería Mobile",
        d: "Desarrollo de aplicaciones de alta complejidad con enfoque en rendimiento nativo y versatilidad multiplataforma.",
        nativeTitle: "Nativo Moderno",
        nativeDesc: "Máximo rendimiento y acceso total al hardware con SwiftUI y Compose para experiencias élite.",
        hybridTitle: "Multiplataforma",
        hybridDesc: "Eficiencia y velocidad de mercado con React Native, Flutter y KMP, manteniendo un código único de alta calidad.",
        compatibility: "Compatibilidad Total",
        version: "Soporte Android 5.0+ / iOS 12+",
        explore: "Explorar Soluciones"
      }
    },
    footer: {
      cta_title: "¿Listo para escalar?",
      cta_subtitle: "Tu infraestructura digital a nivel global.",
      explore: "Explorar",
      stack: "Stack de Servicios",
      status: "Sistema Óptimo",
      node: "Nodo: MX-CDMX-01",
      latency: "Latencia: 14ms",
      rights: "Todos los derechos reservados",
      secure: "Datos Seguros"
    },
    contact: {
      message: "Hola, me gustaría recibir más informes sobre sus servicios."
    },
    methodology: {
      title: "Arquitectura de Proyecto",
      subtitle: "Metodología de alto rendimiento para garantizar escalabilidad y éxito técnico.",
      steps: [
        { n: "01", t: "Discovery & Estrategia", d: "Analizamos sus objetivos de negocio para definir la arquitectura técnica ideal y el stack tecnológico." },
        { n: "02", t: "Diseño & UX", d: "Creamos prototipos de alta fidelidad y flujos de usuario enfocados en la conversión y experiencia élite." },
        { n: "03", t: "Ingeniería Ágil", d: "Desarrollo iterativo con despliegue continuo, asegurando entregas rápidas y código de alta calidad." },
        { n: "04", t: "QA & Despliegue", d: "Pruebas exhaustivas de rendimiento, seguridad y puesta en marcha en entornos de producción escalables." }
      ]
    },
    business_impact: {
      title: "Potencialice su Negocio",
      subtitle: "Convertimos ineficiencias en ventajas competitivas mediante ingeniería de software personalizada.",
      benefits: [
        { title: "Automatización Total", desc: "Eliminamos tareas manuales y repetitivas con sistemas que operan 24/7 sin margen de error." },
        { title: "Escalabilidad Dinámica", desc: "Arquitecturas robustas diseñadas para crecer a la par de su volumen de operaciones." },
        { title: "Inteligencia de Datos", desc: "Transformamos sus datos en decisiones estratégicas mediante dashboards en tiempo real." },
        { title: "Optimización de Costos", desc: "Reducción de gastos operativos mediante la centralización de procesos en un solo ecosistema." }
      ]
    },
    genesis: {
      title: "Nuestra Génesis",
      subtitle: "De la Academia a la Ingeniería Global.",
      text_p1: "TDSMX nació en 2019 como una comunidad universitaria impulsada por la curiosidad técnica. Lo que comenzó como un laboratorio de ideas académicas evolucionó rápidamente hacia una firma de ingeniería de software de alto nivel.",
      text_p2: "A través de años de análisis profundo, aprendimos a desglosar problemáticas complejas para traducirlas en soluciones innovadoras y escalables. Hoy, nuestra identidad une nuestra agilidad de origen con rigor técnico global, materializando visiones digitales que redefinen la eficiencia operativa."
    },
kanan: {
      badge: "PROYECTO ACTIVO // CIVIC TECH",
      hero_title: "Kanan",
      hero_subtitle: "Ecosistema Descentralizado de Mitigación de Riesgo Urbano",
      description: "Un sistema de tecnología cívica diseñado para mapear y reportar incidencias de seguridad pública en tiempo real, procesando datos geográficos mediante un modelo analítico de zonas de riesgo.",
      privacy_btn: "Ver Política de Privacidad de la App",
      back_home: "Volver al Inicio",
      brand_pillars: {
        meaning: {
          tag: "Fundamento Lingüístico",
          title: "El Significado de Kanan",
          desc_p1: "Derivado de la raíz lingüística maya, ",
          desc_highlight1: "Kanan",
          desc_p2: " se traduce directamente como ",
          desc_highlight2: '"Proteger", "Cuidar" o "Vigilar la herencia común"',
          desc_p3: ". No concebimos la plataforma como una herramienta pasiva de monitoreo, sino como una extensión tecnológica de un principio ancestral: el cuidado colectivo de los espacios compartidos."
        },
        logo: {
          tag: "Semiótica Visual",
          title: "Arquitectura del Logotipo",
          desc_p1: "Nuestra identidad visual es un sistema tridimensional de ingeniería de marca. La estructura exterior del escudo evoca la ",
          highlight1: "protección inquebrantable",
          desc_p2: "; el vector orgánico ascendente simboliza los ",
          highlight2: "datos y las métricas de crecimiento analítico",
          desc_p3: "; mientras que la fusión interna del trazado sintetiza la ",
          highlight3: "letra 'K'",
          desc_p4: ", cohesionando el nombre y el propósito técnico en un solo nodo."
        }
      },
      vision: {
        tag: "Visión Técnica",
        title: "El Desafío & Solución"
      },
      ecosystem: {
        section_title: "Componentes del Ecosistema Humano",
        reports: {
          title: "Generación de Reportes",
          desc: "Permite a los ciudadanos reportar incidencias críticas de manera segura mediante formularios parametrizados que capturan tipo de riesgo, hora entre otros datos."
        },
        monitoring: {
          title: "Monitoreo Colectivo",
          desc: "Consulta reportes validados por otros miembros de la comunidad en tiempo real. Información transparente para tomar rutas seguras de traslado."
        },
        community: {
          title: "Tejido Comunitario",
          desc: "Fomentamos una red inteligente que comparte alertas tempranas de zonas de vulnerabilidad, eliminando la asimetría de información en el espacio urbano."
        }
      },
      engineering: {
        section_title: "Core de Ingeniería",
        item1: {
          title: "Mapas de Calor",
          desc: "Visualización e identificación geoespacial de zonas críticas en tiempo real mediante algoritmos de densidad de puntos."
        },
        item2: {
          title: "Participación Cívica",
          desc: "Reportes estructurados y totalmente anónimos diseñados para mitigar la fricción y proteger la identidad del usuario."
        },
        item3: {
          title: "Predicción Analítica",
          desc: "Modelado dinámico de datos históricos e inteligencia geoespacial para la prevención y detección de patrones de incidencias."
        }
      },
      privacy: {
        title: "Política de Privacidad - Kanan",
        badge: "Infraestructura de Datos Segura",
        subtitle: "Protocolo de Tratamiento de Datos, Geolocalización y Cooperación Institucional",
        p1: "1. Anonimato y Recopilación de Datos Limitada: Kanan opera bajo el principio de minimización de datos. La aplicación no recopila, almacena ni procesa datos de identificación personal (PII) tales como nombres, correos electrónicos, números telefónicos o identificadores persistentes de hardware (IMEI/UUID). Los reportes ciudadanos se generan de forma estrictamente anónima.",
        p2: "2. Datos de Geolocalización y Mapas de Calor: Al reportar un incidente, la aplicación solicita acceso único y temporal a las coordenadas GPS del dispositivo. Esta información se procesa localmente en el dispositivo para situar el evento de manera precisa en el mapa. No se realiza ningún rastreo en segundo plano, ni se almacena un historial de ubicación o rutas de los usuarios.",
        p3: "3. Transferencia de Datos y Cooperación de Seguridad: Con el objetivo de mitigar riesgos y mejorar la seguridad pública, los datos de los incidentes reportados (ubicación del evento, tipo de incidente, hora y descripción pública) podrán ser compartidos de forma agregada o individual con instituciones gubernamentales de seguridad, servicios de emergencia y empresas privadas dedicadas a la seguridad y protección civil. Al ser reportes de carácter anónimo y de interés público, esta transferencia no vulnera la privacidad de ningún usuario.",
        p4: "4. Consentimiento y Modificaciones: Al utilizar Kanan y enviar un reporte, usted acepta de manera expresa el tratamiento de los datos del evento bajo los términos aquí descritos. Esta política cumple con los estándares globales de privacidad y sufre actualizaciones conforme cambien los requerimientos operativos de las plataformas de distribución de aplicaciones."
      }
    },
    niya: {
      badge: "PROYECTO ACTIVO // FINTECH ANALYTICS",
      hero_title: "Niya",
      hero_subtitle: "Trazando tu Camino Financiero: Del Control de Gastos a la Predicción Futura",
      description: "Niya elimina la incertidumbre presupuestal. Mediante un registro de gastos simplificado y de baja fricción en su fase inicial, la plataforma recolecta hábitos de consumo para transformarlos en mapas analíticos de proyección, recomendando decisiones financieras óptimas antes de que ocurra un sobreendeudamiento.",
      privacy_btn: "Ver Política de Privacidad de la App",
      back_home: "Volver al Inicio",
      brand_pillars: {
        meaning: {
          tag: "Fundamento Lingüístico",
          title: "El Significado de Niya",
          desc_p1: "Proviene del",
          desc_highlight: "Mazateco de Huautla de Jiménez",
          desc_p2: ", donde Niya (o Ndiyá) significa 'Camino' o 'Sendero'. La aplicación abraza esta metáfora para definir la trayectoria del dinero: entender el camino recorrido para navegar con certeza hacia tus objetivos financieros futuros."
        },
        evolution: {
          tag: "Evolución de Producto",
          title: "Pasado, Presente y Futuro",
          desc: "Diseñada con un roadmap escalable. Comienza como una herramienta intuitiva de control de gastos diarios (MVP en el presente) y evoluciona en un motor predictivo que analiza tu historial financiero (pasado) para aconsejarte y trazar una ruta segura de ahorro (futuro)."
        }
      },
      vision: {
        tag: "Visión Técnica",
        title: "El Desafío & Solución"
      },
      pathway: {
        section_title: "El Sendero Financiero",
        past: {
          title: "El Pasado (Histórico)",
          desc: "Registro acumulativo y auditoría de consumos. Identificación de patrones de gasto y detección de fugas silenciosas de capital."
        },
        present: {
          title: "El Presente (MVP Control)",
          desc: "Captura ultrarrápida de egresos e ingresos cotidianos, balance diario y semáforo presupuestal en tiempo real."
        },
        future: {
          title: "El Futuro (Predictivo)",
          desc: "Simulaciones de liquidez a fin de mes, recomendaciones automatizadas de ahorro y asesoría financiera basada en IA."
        }
      },
      engineering: {
        section_title: "Core de Ingeniería",
        item1: {
          title: "Tracking Inteligente",
          desc: "Clasificación paramétrica de movimientos para estructurar la salud financiera sin esfuerzo."
        },
        item2: {
          title: "Proyección Algorítmica",
          desc: "Modelado predictivo basado en series de tiempo para calcular tu balance futuro estimado."
        },
        item3: {
          title: "Consejos Contextuales",
          desc: "Motor de alertas tempranas que sugiere ajustes en compras impulsivas antes de afectar tus metas."
        }
      },
      privacy: {
        title: "Política de Privacidad de Niya",
        badge: "Protección Analítica de Datos",
        subtitle: "Privacidad y seguridad en la trayectoria financiera",
        p1: "Niya procesa tus registros financieros bajo cifrado local y de extremo a extremo, garantizando que el mapa de tus consumos sea totalmente confidencial.",
        p2: "Los modelos predictivos analizan tus datos históricos exclusivamente de forma aislada en tu dispositivo sin comerciar con tus datos.",
        p3: "Tienes la autonomía total para exportar o borrar definitivamente tu historial en cualquier momento."
      }
    },
    blebe: {
      badge: "PLATAFORMA CORPORATIVA // HR-TECH & RECRUITMENT SUITE",
      hero_title: "Blebé",
      hero_subtitle: "Ecosistema Automatizado de Selección y RRHH: Evaluación Psicométrica Completa, Análisis Inteligente de CV, Estudio Socioeconómico con Geolocalización y Gestión Documental Schema-Driven.",
      description: "Blebé digitaliza y automatiza los cuellos de botella del reclutamiento tradicional. Unifica el filtrado de CVs mediante IA en el Portal Admin, una batería psicométrica de 6 pruebas estandarizadas, recolección documental multi-archivo y un estudio socioeconómico con geolocalización inteligente en segundo plano sin drenaje de batería.",
      privacy_btn: "Ver Aviso de Privacidad y Cumplimiento Legal",
      back_home: "Volver al Inicio",
      brand_pillars: {
        meaning: {
          tag: "Origen Lingüístico",
          title: "El Significado de Blebé",
          desc_p1: "Proviene de la variante del ",
          highlight1: "Zapoteco de la Sierra Juárez",
          desc_p2: ", donde ",
          highlight2: "Blebé",
          desc_p3: " significa ",
          highlight3: '"Escogido"',
          desc_p4: " o ",
          highlight4: '"Elegido"',
          desc_p5: ". Representa el núcleo del reclutamiento de alta precisión: filtrar y encontrar el talento idóneo para cada organización a través de tecnología y datos certeros."
        },
        logo: {
          tag: "Arquitectura del Isotipo",
          title: "Unión, Infinito y Selección",
          desc_p1: "Constituido por dos módulos abstractos que se entrelazan formando una ",
          highlight1: '"X"',
          desc_p2: " (el marcador de selección) y el símbolo de ",
          highlight2: "infinito (∞)",
          desc_p3: ". Proyecta la red permanente de contactos entre empresa y postulante, junto a un ciclo continuo de crecimiento profesional."
        }
      },
      vision: {
        tag: "Propuesta de Valor",
        title: "El Desafío & Solución"
      },
      ecosystem: {
        section_title: "Ecosistema Integral de Selección",
        portal: {
          title: "Portal Admin & CV Parsing",
          desc: "Dashboard ejecutivo para gestión de vacantes, extracción automática de entidades en CVs y scoring algorítmico de adecuación al puesto."
        },
        psychometrics: {
          title: "Batería de 6 Pruebas",
          desc: "Evaluación automatizada de Personalidad, Coeficiente Intelectual, Comportamiento, Liderazgo, Valores y Adaptabilidad al entorno laboral."
        },
        dossier: {
          title: "Expediente Schema-Driven",
          desc: "Recaudación documental con soporte multi-archivo (hasta 10 comprobantes, 5 cartas laborales) y doble cara (Front/Back) para identificaciones oficiales."
        }
      },
      deep_dive: {
        cv_parsing: {
          title: "Parsing & Análisis de CV",
          f1: "Extracción automática de experiencia, habilidades y educación.",
          f2: "Scoring de compatibilidad con el perfil descriptivo del puesto.",
          f3: "Comparativa entre múltiples candidatos desde el portal."
        },
        socioeconomic: {
          title: "Estudio Socioeconómico",
          f1: "Formulario dinámico en 8 pasos con validación de balance financiero.",
          f2: "Verificación de trayectoria laboral y referencias vecinales.",
          f3: "Validación fotográfica de domicilio con captura de coordenadas GPS."
        }
      },
      geolocation: {
        tag: "Arquitectura Android",
        title: "Geolocalización de Bajo Consumo (3 Días)",
        desc_p1: "Diseñado para validar el arraigo domiciliario del candidato capturando coordenadas cada hora de ",
        highlight1: "10:00 PM a 6:00 AM",
        desc_p2: " y de forma aleatoria (35% de probabilidad) durante el día, calculando el ",
        highlight2: "Top 3 de zonas aproximadas",
        desc_p3: " con un ciclo de vida autónomo de 72 horas.",
        advantages_title: "Ventajas frente a Métodos Tradicionales",
        battery: {
          title: "Cero Drenaje de Batería",
          desc_p1: "En lugar de mantener el GPS activo continuamente (300 mA), utiliza ",
          desc_p2: " con ",
          desc_p3: " basándose en Wi-Fi y torres celulares (ahorro del 80% de energía)."
        },
        offline: {
          title: "Arquitectura Offline-First",
          desc: "Si el candidato no tiene conexión a internet, las coordenadas se almacenan en una cola local protegida. Al detectar conectividad Wi-Fi o datos, se sincroniza todo el lote (*batch*) en un único llamado a Firestore."
        },
        doze: {
          title: "Respeto a Doze Mode",
          desc_p1: "A diferencia de los ",
          highlight1: "Foreground Services",
          desc_p2: " que colocan notificaciones invasivas o ",
          highlight2: "AlarmManager",
          desc_p3: " que es bloqueado en Android 12+, WorkManager sincroniza tareas en las ventanas de mantenimiento del SO sin interrumpir al usuario."
        }
      },
      engineering: {
        section_title: "Core de Ingeniería",
        item1: {
          title: "Remote Flags & Dynamic UI",
          desc: "Motor dinámico que habilita u oculta secciones según la configuración de la vacante en Firestore."
        },
        item2: {
          title: "Cifrado & Almacenamiento",
          desc: "Transacciones seguras en Firebase Storage SDK con purga automática de temporales en caché local."
        },
        item3: {
          title: "I18n & Jetpack Compose",
          desc: "Soporte nativo multilenguaje (Español / Inglés) estructurado en componentes reactivos de alto rendimiento."
        }
      },
      privacy: {
        title: "Aviso de Privacidad y Confidencialidad",
        badge: "Protección de Datos Personales en Reclutamiento",
        subtitle: "Tratamiento de Información de Candidatos",
        p1: "Los datos personales, currículums, evaluaciones psicométricas, documentos de identificación y registros socioeconómicos recolectados por Blebé son estrictamente confidenciales y protegidos conforme a las leyes aplicables de protección de datos.",
        p2: "La información médica, laboral, psicológica y patrimonial se recopila con fines exclusivos de validación interna e idoneidad para el puesto, garantizando en todo momento el principio de no discriminación.",
        p3: "Los datos de geolocalización y evidencias fotográficas se procesan de forma automatizada únicamente para comprobar la autenticidad del domicilio declarado durante el proceso de selección."
      }
    },
    marchantite: {
      badge: "EL MERCADO LOCAL EN LA PUERTA DE TU HOGAR",
      hero_title: "Marchantite",
      description: "Conectamos directamente contigo para ofrecerte la mayor frescura, calidad y calidez de nuestros marchantes locales con entregas el mismo día.",
      terms_btn: "Ver Políticas de Servicio y Entrega",
      back_home: "Volver al Inicio",
      pillars: {
        local: {
          tag: "Comercio Local",
          title: "Apoyo 100% Local",
          desc: "Conectamos de forma directa con los mercados locales para ofrecer la calidez de tus puestos de confianza."
        },
        logistics: {
          tag: "Logística Eficiente",
          title: "Entregas el Mismo Día",
          desc: "Del mercado a tu cocina, garantizando la máxima frescura diaria de tus frutas, verduras y abarrotes."
        },
        quality: {
          tag: "Garantía de Calidad",
          title: "Selección Cuidadosa",
          desc: "Elegimos cada producto con la misma dedicación, detalle y cariño con el que tú lo harías."
        }
      },
      customer_experience: {
        section_title: "Experiencia Integral para el Cliente",
        discovery: {
          tag: "Descubrimiento Inteligente",
          title: "Mercados Cercanos & Exploración de Locales",
          desc: "Accede a la oferta completa de los mercados tradicionales más próximos a tu ubicación. Navega por local, visualiza los insumos disponibles por categoría y conoce la variedad que cada marchante ofrece sin salir de casa.",
          f1: "Filtro por Giros Comerciales (Frutas, Carnes, Abarrotes, etc.)",
          f2: "Geolocalización para detectar tus mercados de zona",
          f3: "Catálogo visual organizado por puestos locales",
          f4: "Multidirección para enviar a casa o a familiares"
        },
        schedule: {
          title: "Horarios Programados",
          desc: "Planifica tu mandado con anticipación. Selecciona el bloque de entrega que mejor se adapte a tus tiempos dentro de la ventana de servicio (8:00 AM a 8:00 PM).",
          restriction: "Restricciones de agenda adaptadas al horario de los mercados."
        },
        search: {
          title: "Buscador & Favoritos",
          desc: "Encuentra ingredientes específicos al instante o guarda tus productos preferidos en listas para repetir tus compras semanales en un solo clic."
        },
        reviews: {
          title: "Opiniones & Avisos",
          desc: "Consulta calificaciones de otros compradores sobre la calidad de cada puesto y recibe notificaciones en tiempo real directamente de tus locatarios."
        },
        cart: {
          title: "Carrito Unificado",
          desc: "Gestiona pedidos multi-puesto de forma clara. Revisa el detalle de tus productos seleccionados antes de enviar la orden a preparación."
        }
      },
      operational_support: {
        section_title: "Soporte Operativo de la Cadena",
        merchants: {
          title: "Gestión para Locatarios",
          desc: "Herramientas para que el comerciante administre su puesto digitalmente:",
          f1: "Actualización de catálogo de temporada y ofertas diarias.",
          f2: "Confirmación y preparación rápida de pedidos recibidos.",
          f3: "Configuración flexible de horarios y avisos a clientes."
        },
        couriers: {
          title: "Logística de Repartidores",
          desc: "Garantiza que el mandado llegue fresco y completo:",
          f1: "Asignación de rutas optimizadas para rápida recolección.",
          f2: "Mensajería directa con el cliente para sugerir sustitutos.",
          f3: "Actualización transparente del estado del envío en tiempo real."
        }
      },
      shipping_rates: {
        tag: "Transparencia en el Servicio",
        title: "Tarifas de Envío por Distancia",
        desc: "Calculamos el costo del envío basándonos en la distancia exacta entre el mercado de origen y tu domicilio, asegurando tarifas justas y transparentes.",
        col_range: "Rango de Distancia",
        col_cost: "Costo de Envío",
        col_conditions: "Condiciones de Servicio",
        range1: "0 a 500 mts",
        range2: "501 a 1,000 mts",
        range3: "1,001 a 1,500 mts",
        range4: "1,501 a 2,000 mts",
        conditions_detail: {
          coverage: "Cobertura máxima: 2.0 km (2,000 mts)",
          capacity: "Capacidad máxima por ruta: 50 kg",
          guarantee: "Garantía de frescura del mercado a tu cocina."
        }
      },
      policy_modal: {
        title: "Políticas de Servicio y Entregas",
        subtitle: "Marchantite User Guidelines",
        section1_title: "Compromiso de Calidad y Carga",
        section1_text: "Para garantizar que cada producto mantenga su integridad y frescura, cada repartidor maneja un límite de carga máximo de 50 kg por ruta. Esto previene daños en alimentos frágiles o perecederos.",
        section2_title: "Rutas Directas y Eficientes",
        section2_text: "La plataforma prioriza el envío calculando la secuencia de entrega óptima desde el mercado más cercano hasta tu puerta, garantizando tiempos de espera reducidos.",
        section3_title: "Radio de Cobertura",
        section3_text: "El servicio está acotado a un radio máximo de 2.0 kilómetros alrededor de cada mercado local participante para preservar la calidad de los alimentos de consumo diario."
      }
    }
  },
  en: {
    nav: {
      home: "Home",
      portfolio: "Portfolio",
      projects: "Projects",
      capabilities: "Services",
      contact: "Contact",
      kanan: "Kanan",
      niya: "Niya",
      marchantite: "Marchantite",
      blebe: "Blebé"
    },
    hero: {
      badge: "The Dark Side MX",
      t1: "Digital Project",
      t2: "Construction & Scaling",
      d: "We materialize your digital vision. We build high-performance software ecosystems designed to optimize your business model's profitability and growth.",
      cta: "Start Project",
      explore: "Explore Capabilities"
    },
    services: {
      title: "Software Engineering",
      subtitle: "High-Level Solutions",
      viewProject: "Visit Project",
      web: {
        t: "Web Ecosystems",
        d: "Scalable architectures for SaaS and enterprise platforms requiring high availability and extreme loading speeds."
      },
      mobile: {
        t: "Mobile Engineering",
        d: "High-complexity application development with a focus on native performance and multi-platform versatility.",
        nativeTitle: "Modern Native",
        nativeDesc: "Peak performance and full hardware access using SwiftUI and Compose for elite user experiences.",
        hybridTitle: "Multi-platform",
        hybridDesc: "Cost efficiency and speed to market with React Native, Flutter, and KMP, maintaining high-quality shared code.",
        compatibility: "Full Compatibility",
        version: "Android 5.0+ / iOS 12+ Support",
        explore: "Explore Solutions"
      }
    },
    footer: {
      cta_title: "Ready to scale?",
      cta_subtitle: "Your digital infrastructure at a global scale.",
      explore: "Explore",
      stack: "Service Stack",
      status: "System Optimal",
      node: "Node: MX-CDMX-01",
      latency: "Latency: 14ms",
      rights: "All rights reserved",
      secure: "Secure Data"
    },
    contact: {
      message: "Hello, I would like more information about your services."
    },
    methodology: {
      title: "Project Architecture",
      subtitle: "High-performance methodology to ensure scalability and technical success.",
      steps: [
        { n: "01", t: "Discovery & Strategy", d: "We analyze your business objectives to define the ideal technical architecture and technology stack." },
        { n: "02", t: "Design & UX", d: "We create high-fidelity prototypes and user flows focused on conversion and elite experiences." },
        { n: "03", t: "Agile Engineering", d: "Iterative development with continuous deployment, ensuring fast delivery and clean, high-quality code." },
        { n: "04", t: "QA & Deployment", d: "Exhaustive performance and security testing, followed by launch in scalable production environments." }
      ]
    },
    business_impact: {
      title: "Boost Your Business",
      subtitle: "We turn inefficiencies into competitive advantages through custom software engineering.",
      benefits: [
        { title: "Total Automation", desc: "Eliminating manual, repetitive tasks with intelligent systems that operate 24/7 error-free." },
        { title: "Dynamic Scalability", desc: "Robust architectures designed to grow alongside your operational volume." },
        { title: "Data Intelligence", desc: "Transforming data into strategic decisions via real-time operational dashboards." },
        { title: "Cost Optimization", desc: "Reducing overhead by centralizing business processes into one unified ecosystem." }
      ]
    },
    genesis: {
      title: "Our Genesis",
      subtitle: "From Academy to Global Engineering.",
      text_p1: "TDSMX was born in 2019 as a university community driven by technical curiosity. What began as an academic ideas lab quickly evolved into a high-level software engineering firm.",
      text_p2: "Through years of deep analysis, we learned to break down complex problems to translate them into innovative and scalable solutions. Today, our identity unites our agile origin with global technical rigor, materializing digital visions that redefine operational efficiency."
    },
    kanan: {
      badge: "ACTIVE PROJECT // CIVIC TECH",
      hero_title: "Kanan",
      hero_subtitle: "Decentralized Urban Risk Mitigation Ecosystem",
      description: "A civic technology system designed to map and report public safety incidents in real-time, processing geographic data through a risk zone analytical model.",
      privacy_btn: "View App Privacy Policy",
      back_home: "Back to Home",
      brand_pillars: {
        meaning: {
          tag: "Linguistic Foundation",
          title: "The Meaning of Kanan",
          desc_p1: "Derived from the Mayan linguistic root, ",
          desc_highlight1: "Kanan",
          desc_p2: " translates directly to ",
          desc_highlight2: '"To Protect", "To Care for", or "To Guard shared heritage"',
          desc_p3: ". We do not envision the platform as a passive monitoring tool, but as a technological extension of an ancestral principle: collective stewardship of shared spaces."
        },
        logo: {
          tag: "Visual Semiotics",
          title: "Logo Architecture",
          desc_p1: "Our visual identity is a three-dimensional brand engineering system. The shield's outer structure evokes ",
          highlight1: "unwavering protection",
          desc_p2: "; the ascending organic vector symbolizes ",
          highlight2: "data and analytical growth metrics",
          desc_p3: "; while the internal trace fusion synthesizes the ",
          highlight3: "letter 'K'",
          desc_p4: ", uniting name and technical purpose into a single node."
        }
      },
      vision: {
        tag: "Technical Vision",
        title: "The Challenge & Solution"
      },
      ecosystem: {
        section_title: "Human Ecosystem Components",
        reports: {
          title: "Report Generation",
          desc: "Allows citizens to securely report critical incidents through parameterized forms capturing risk type, time, and additional contextual data."
        },
        monitoring: {
          title: "Collective Monitoring",
          desc: "Access real-time reports validated by fellow community members. Transparent information to choose safe transit routes."
        },
        community: {
          title: "Community Fabric",
          desc: "We foster a smart network sharing early warnings for vulnerable areas, eliminating information asymmetry across urban spaces."
        }
      },
      engineering: {
        section_title: "Engineering Core",
        item1: {
          title: "Heatmaps",
          desc: "Geospatial visualization and identification of critical zones in real-time using point-density algorithms."
        },
        item2: {
          title: "Civic Engagement",
          desc: "Structured, completely anonymous reports engineered to reduce friction and safeguard user identity."
        },
        item3: {
          title: "Predictive Analytics",
          desc: "Dynamic modeling of historical data and geospatial intelligence for incident pattern prevention and detection."
        }
      },
      privacy: {
        title: "Privacy Policy - Kanan",
        badge: "Secure Data Infrastructure",
        subtitle: "Data Handling, Geolocation & Institutional Cooperation Protocol",
        p1: "1. Anonymity and Limited Data Collection: Kanan operates under the data minimization principle. The application does not collect, store, or process Personally Identifiable Information (PII) such as names, email addresses, phone numbers, or persistent hardware identifiers (IMEI/UUID). Citizen reports are generated strictly anonymously.",
        p2: "2. Geolocation Data and Heatmaps: When reporting an incident, the app requests one-time, temporary access to device GPS coordinates. This information is processed locally on-device to position the event precisely on the map. No background tracking is performed, and no user location or route history is ever stored.",
        p3: "3. Data Transfer and Security Cooperation: To mitigate risks and improve public safety, reported incident data (event location, incident type, time, and public description) may be shared in aggregated or individual formats with government security institutions, emergency services, and private security or civil protection firms. Since these are anonymous reports of public interest, this transfer does not violate any user's privacy.",
        p4: "4. Consent and Modifications: By using Kanan and submitting a report, you expressly consent to event data processing under the terms described herein. This policy complies with global privacy standards and updates in accordance with app store distribution requirements."
      }
    },
    niya: {
      badge: "ACTIVE PROJECT // FINTECH ANALYTICS",
      hero_title: "Niya",
      hero_subtitle: "Mapping Your Financial Path: From Expense Tracking to Future Prediction",
      description: "Niya eliminates budgetary uncertainty. Through a simplified, low-friction expense log in its initial phase, the platform collects spending habits to convert them into analytical projection maps, recommending optimal financial decisions before over-indebtedness occurs.",
      privacy_btn: "View App Privacy Policy",
      back_home: "Back to Home",
      brand_pillars: {
        meaning: {
          tag: "Linguistic Foundation",
          title: "The Meaning of Niya",
          desc_p1: "Originating from",
          desc_highlight: "Mazatec of Huautla de Jiménez",
          desc_p2: ", where Niya (or Ndiyá) means 'Path' or 'Trail'. The application embraces this metaphor to define money's journey: understanding the path traveled to navigate confidently toward future financial goals."
        },
        evolution: {
          tag: "Product Evolution",
          title: "Past, Present & Future",
          desc: "Built on a scalable roadmap. It begins as an intuitive daily expense tracking tool (MVP in the present) and evolves into a predictive engine that analyzes your financial history (past) to advise and build a secure savings path (future)."
        }
      },
      vision: {
        tag: "Technical Vision",
        title: "The Challenge & Solution"
      },
      pathway: {
        section_title: "The Financial Pathway",
        past: {
          title: "The Past (Historical)",
          desc: "Cumulative tracking and spending audits. Pattern recognition and detection of silent capital leaks."
        },
        present: {
          title: "The Present (MVP Tracking)",
          desc: "Ultra-fast daily expense and income logging, real-time daily balance, and budget status indicators."
        },
        future: {
          title: "The Future (Predictive)",
          desc: "End-of-month liquidity simulations, automated savings recommendations, and AI-driven financial guidance."
        }
      },
      engineering: {
        section_title: "Engineering Core",
        item1: {
          title: "Smart Tracking",
          desc: "Parametric classification of transactions to organize financial health effortlessly."
        },
        item2: {
          title: "Algorithmic Projection",
          desc: "Time-series predictive modeling to estimate your future cash balance."
        },
        item3: {
          title: "Contextual Advice",
          desc: "Early warning engine suggesting adjustments to impulse purchases before impacting your goals."
        }
      },
      privacy: {
        title: "Niya Privacy Policy",
        badge: "Data Analytics Protection",
        subtitle: "Privacy and Security on Your Financial Path",
        p1: "Niya processes your financial logs using local and end-to-end encryption, ensuring that your spending roadmap remains completely confidential.",
        p2: "Predictive models analyze your historical data strictly on-device in isolation, without trading or monetizing your personal data.",
        p3: "You maintain total autonomy to export or permanently delete your history at any given time."
      }
    },
    blebe: {
      badge: "ENTERPRISE PLATFORM // HR-TECH & RECRUITMENT SUITE",
      hero_title: "Blebé",
      hero_subtitle: "Automated Recruitment & HR Ecosystem: Comprehensive Psychometric Testing, Intelligent CV Parsing, Geolocated Socioeconomic Audits, and Schema-Driven Document Management.",
      description: "Blebé digitizes and automates traditional recruitment bottlenecks. It unifies AI CV filtering within the Admin Portal, a 6-test standardized psychometric suite, multi-file document collection, and a background geolocated socioeconomic study engineered without battery drain.",
      privacy_btn: "View Privacy Notice & Legal Compliance",
      back_home: "Back to Home",
      brand_pillars: {
        meaning: {
          tag: "Linguistic Origin",
          title: "The Meaning of Blebé",
          desc_p1: "Originates from the ",
          highlight1: "Sierra Juárez Zapotec",
          desc_p2: " dialect, where ",
          highlight2: "Blebé",
          desc_p3: " means ",
          highlight3: '"Chosen"',
          desc_p4: " or ",
          highlight4: '"Selected"',
          desc_p5: ". It represents the essence of precision recruitment: filtering and identifying ideal organizational talent through reliable technology and data."
        },
        logo: {
          tag: "Isotype Architecture",
          title: "Union, Infinity & Selection",
          desc_p1: "Formed by two abstract interwoven modules shaping an ",
          highlight1: '"X"',
          desc_p2: " (the selection marker) and the ",
          highlight2: "infinity symbol (∞)",
          desc_p3: ". It projects an enduring network connecting companies and applicants alongside a continuous cycle of professional growth."
        }
      },
      vision: {
        tag: "Value Proposition",
        title: "The Challenge & Solution"
      },
      ecosystem: {
        section_title: "Comprehensive Selection Ecosystem",
        portal: {
          title: "Admin Portal & CV Parsing",
          desc: "Executive dashboard for job opening management, automatic CV entity extraction, and algorithmic job-fit scoring."
        },
        psychometrics: {
          title: "6-Test Battery",
          desc: "Automated assessment covering Personality, IQ, Behavior, Leadership, Values, and Workplace Adaptability."
        },
        dossier: {
          title: "Schema-Driven Dossier",
          desc: "Document collection supporting multi-file uploads (up to 10 utility bills, 5 reference letters) and double-sided (Front/Back) IDs."
        }
      },
      deep_dive: {
        cv_parsing: {
          title: "CV Parsing & Analysis",
          f1: "Automated extraction of experience, skills, and educational background.",
          f2: "Compatibility scoring matched against job profile specifications.",
          f3: "Multi-candidate side-by-side comparison from the portal."
        },
        socioeconomic: {
          title: "Socioeconomic Study",
          f1: "Dynamic 8-step form with financial balance verification.",
          f2: "Work history verification and neighborhood reference checks.",
          f3: "Photographic home validation with GPS coordinate capture."
        }
      },
      geolocation: {
        tag: "Android Architecture",
        title: "Low-Power Geolocation (3-Day Cycle)",
        desc_p1: "Engineered to validate applicant residential stability by logging coordinates hourly from ",
        highlight1: "10:00 PM to 6:00 AM",
        desc_p2: " and randomly (35% probability) during daytime, calculating the ",
        highlight2: "Top 3 approximate location zones",
        desc_p3: " with an autonomous 72-hour lifecycle.",
        advantages_title: "Advantages Over Traditional Methods",
        battery: {
          title: "Zero Battery Drain",
          desc_p1: "Instead of keeping GPS continuously active (300 mA), it leverages ",
          desc_p2: " with ",
          desc_p3: " utilizing Wi-Fi and cell towers (saving 80% power)."
        },
        offline: {
          title: "Offline-First Architecture",
          desc: "If the applicant lacks internet connectivity, coordinates queue in a protected local database. Upon detecting Wi-Fi or cellular data, the entire batch syncs in a single Firestore call."
        },
        doze: {
          title: "Doze Mode Compliance",
          desc_p1: "Unlike ",
          highlight1: "Foreground Services",
          desc_p2: " displaying invasive notifications or ",
          highlight2: "AlarmManager",
          desc_p3: " restricted in Android 12+, WorkManager schedules tasks during OS maintenance windows without disturbing the user."
        }
      },
      engineering: {
        section_title: "Engineering Core",
        item1: {
          title: "Remote Flags & Dynamic UI",
          desc: "Dynamic engine enabling or hiding sections based on job opening configurations stored in Firestore."
        },
        item2: {
          title: "Encryption & Storage",
          desc: "Secure transactions using Firebase Storage SDK with automated local cache temporary purging."
        },
        item3: {
          title: "I18n & Jetpack Compose",
          desc: "Native multi-language support (Spanish / English) structured within high-performance reactive UI components."
        }
      },
      privacy: {
        title: "Privacy & Confidentiality Notice",
        badge: "Personal Data Protection in Recruitment",
        subtitle: "Candidate Data Processing Protocol",
        p1: "Personal data, resumes, psychometric evaluations, identification documents, and socioeconomic records collected by Blebé are strictly confidential and protected pursuant to applicable data protection legislation.",
        p2: "Medical, employment, psychological, and financial details are gathered exclusively for internal verification and job fitness assessment, ensuring non-discrimination principles at all times.",
        p3: "Geolocation coordinates and photographic evidence are processed automatically solely to verify the authenticity of declared residential addresses during recruitment."
      }
    },
    marchantite: {
      badge: "LOCAL MARKETS AT YOUR DOORSTEP",
      hero_title: "Marchantite",
      description: "We connect directly with you to offer the freshest, highest quality products from our local market merchants with same-day delivery.",
      terms_btn: "View Service & Delivery Policies",
      back_home: "Back to Home",
      pillars: {
        local: {
          tag: "Local Commerce",
          title: "100% Local Support",
          desc: "We connect directly with local markets to bring you the warmth of your trusted stands."
        },
        logistics: {
          tag: "Efficient Logistics",
          title: "Same-Day Delivery",
          desc: "From the market to your kitchen, ensuring maximum daily freshness for your fruits, vegetables, and groceries."
        },
        quality: {
          tag: "Quality Guarantee",
          title: "Careful Selection",
          desc: "We select each product with the same dedication, attention to detail, and care as you would."
        }
      },
      customer_experience: {
        section_title: "Comprehensive Customer Experience",
        discovery: {
          tag: "Smart Discovery",
          title: "Nearby Markets & Local Stand Exploration",
          desc: "Access the full selection of traditional markets nearest to your location. Browse by stand, view available supplies by category, and explore the variety each merchant offers without leaving home.",
          f1: "Filter by Business Category (Fruits, Meats, Groceries, etc.)",
          f2: "Geolocation to detect your neighborhood markets",
          f3: "Visual catalog organized by local stands",
          f4: "Multi-address support to send orders home or to family members"
        },
        schedule: {
          title: "Scheduled Delivery Blocks",
          desc: "Plan your grocery shopping in advance. Choose the delivery time slot that best fits your schedule within our operating window (8:00 AM to 8:00 PM).",
          restriction: "Schedule constraints aligned with market operating hours."
        },
        search: {
          title: "Search & Favorites",
          desc: "Find specific ingredients instantly or save your favorite items in custom lists to repeat weekly purchases with a single click."
        },
        reviews: {
          title: "Reviews & Announcements",
          desc: "Check ratings from other buyers regarding stand quality and receive real-time updates directly from your local merchants."
        },
        cart: {
          title: "Unified Cart",
          desc: "Manage multi-stand orders clearly. Review detailed item selections before dispatching your order for fulfillment."
        }
      },
      operational_support: {
        section_title: "Supply Chain Operational Support",
        merchants: {
          title: "Merchant Management",
          desc: "Digital tools enabling vendors to manage their stand efficiently:",
          f1: "Seasonal catalog updates and daily special offers.",
          f2: "Quick order confirmation and preparation workflows.",
          f3: "Flexible business hour settings and customer notifications."
        },
        couriers: {
          title: "Courier Logistics",
          desc: "Ensuring groceries arrive fresh and complete:",
          f1: "Optimized route assignment for swift pickup.",
          f2: "Direct messaging with customers to suggest item substitutes.",
          f3: "Transparent real-time delivery status updates."
        }
      },
      shipping_rates: {
        tag: "Service Transparency",
        title: "Distance-Based Shipping Rates",
        desc: "Delivery costs are calculated based on the exact distance between the origin market and your destination address, ensuring fair and transparent pricing.",
        col_range: "Distance Range",
        col_cost: "Shipping Cost",
        col_conditions: "Service Terms",
        range1: "0 to 500 m",
        range2: "501 to 1,000 m",
        range3: "1,001 to 1,500 m",
        range4: "1,501 to 2,000 m",
        conditions_detail: {
          coverage: "Maximum coverage radius: 2.0 km (2,000 m)",
          capacity: "Maximum weight per route: 50 kg",
          guarantee: "Guaranteed freshness from market to kitchen."
        }
      },
      policy_modal: {
        title: "Service & Delivery Policies",
        subtitle: "Marchantite User Guidelines",
        section1_title: "Quality & Capacity Commitment",
        section1_text: "To guarantee that every product maintains its integrity and freshness, each courier handles a maximum weight limit of 50 kg per route. This prevents damage to fragile or perishable goods.",
        section2_title: "Direct & Efficient Routing",
        section2_text: "The platform prioritizes delivery by calculating the optimal sequence from the nearest market directly to your doorstep, minimizing waiting times.",
        section3_title: "Coverage Radius",
        section3_text: "Service is restricted to a maximum radius of 2.0 kilometers around participating local markets to preserve daily food quality."
      }
    }
  }
};